import React from 'react'

import SEO from 'src/components/seo/index'
import Header from 'src/components/header/setting'
import Mainview from 'src/components/mainview/index'
import Title from 'src/components/title/index'
import Inner from 'src/components/inner/index'
import Image from 'src/components/image/index'
import Link from 'src/components/link/index'
// import Information from 'src/components/information/index'
import Features from 'src/components/features/index'
import Slider from 'src/components/news/slider'
import Facility from 'src/components/facility/index'
import GoogleMap from 'src/components/googlemap/index'
import ReadyToGo from 'src/components/readytogo/index'

import styles from '../index.module.scss'

const GymPage = () => {
	const send = (name) => {
		if (`gtag` in window) {
			window.gtag(`event`, `click`, {
				event_category: `formlink`,
				event_label: name,
				value: 1,
			})
		}
	}

	return (
		<div>
			<SEO
				title="用賀店"
				description="WE ARE THE FITは用賀駅から徒歩1分にある24時間営業のフィットネスジムです。本格マシーンを多数取り揃え、パーソナルトレーニング、ボディメイクプランも承っています。初心者向けエリアもご用意しておりますので、まずはお気軽にご見学にお越しください。"
			/>
			<Header hasBack={false} />

			<Mainview className={styles.mainView + ` ` + styles.mainViewNoInfo}>
				<div className={styles.mainBody}>
					<div className={styles.mainImage}>
						<Image src="/gyms/yoga/mainview.webp" />
					</div>
					<div className={styles.mainTitle}>
						<span>WE ARE THE FIT</span>
						<h1>YOGA</h1>
					</div>
				</div>
				{/* <Information gym="yoga" /> */}
			</Mainview>

			<section className={styles.news}>
				<Title
					h2="NEWS"
					right={
						<Link className={styles.newsLink} to="/news/">
							View All News
						</Link>
					}
				/>
				<div className={styles.newsList}>
					<Slider filter="yoga" />
				</div>
				<div className={styles.newsAll}>
					<Link to="/news/">View All News</Link>
				</div>
			</section>

			<section className={styles.features}>
				<Title
					h2="FEATURE"
					sub={
						<div className={styles.subtitle}>
							ワークアウトが初めての方でも扱いやすいマシンを集めたフロアと上級者も満足いくマシンを揃えたフロア。それそれ適した環境を備えた空間は、これまでの24時間ジムでは得られなかった体験をお届けします。
						</div>
					}
				/>
				<div className={styles.featuresList}>
					<Features
						items={[
							{
								title: `特徴１：初心者向けフロア`,
								text: `フィットネス初心者でも、ご安心ください。<br />WE ARE THE FITは初心者向けフロアをご用意しておりますので、周りに気兼ねなく安心してご利用いただけます。<br />スタッフによる施設案内・マシーンの使い方の説明・カウンセリング・トレーニングサポートプランを無料で実施。1対1のサポートですので、初めての方でもご心配なく。<br />初回でなくても、不明点・ご質問などあればいつでもスタッフにお声がけください。`,
								image: `/gyms/yoga/feature_01.webp`,
							},
							{
								title: `特徴２：上級者向けフロア`,
								text: `最新マシーンを揃えた上級者フロアで、本格的なトレーニングを。<br />トレーニングに慣れてきた方、本格的なボディーメイクのための最新マシーンを揃えた上級者フロアを用意しています。特にフリーウェイトマシンの種類の豊富さには自信があります。ダンベルも最高50kgまでご用意。各種アクセサリーも豊富にご用意しております。`,
								image: `/gyms/yoga/feature_02.webp`,
							},
							{
								title: `特徴３：24時間利用可能`,
								text: `WE ARE THE FITは、24時間営業のフィットネスクラブです。<br />スタッフの常駐していない早朝・深夜帯でも、セキュリティカードをかざすだけでいつでも施設を利用できます。しっかりセキュリティ対策もされているので女性の方の深夜帯利用も安心です。`,
								image: `/gyms/yoga/feature_03.webp`,
							},
							{
								title: `特徴４：本格マシーン多数設置`,
								text: `世界標準の最新マシーンを多数取り揃えました。かなり自信があります。本格的なマシーンを使ったトレーニングで理想のカラダ作りを。効果的なトレーニングに欠かせないアクセサリーの種類も豊富にご用意。`,
								image: `/gyms/yoga/feature_04.webp`,
							},
							{
								title: `特徴５：トレーニングのサポート`,
								text: `WE ARE THE FITにはトレーニングに精通したスタッフが常駐しております（スタッフ在中時間帯）。マシンの使い方を紹介したり、トレーニングアドバイスなどご質問にあわせてサポートいたします。ご入会時にはビギナーズサポートとして無料のサポートプランをご用意。1対1での丁寧なサポートでトレーニングが初めての方にも続けやすい環境を準備してお待ちしております。`,
								image: `/gyms/yoga/feature_05.webp`,
							},
						]}
					/>
				</div>
			</section>

			<section className={styles.services}>
				<Title h2="SERVICES" />
				<Inner>
					<ul className={styles.servicesGrid}>
						<li>
							<h3>Basic Support</h3>
							<em>ベーシックサポート</em>
							<p>
								「Basic
								Support」は、ジム初心者や、マシンの使い方に不安を感じる方に最適なサポートサービスです。専任スタッフがマンツーマンで丁寧にマシンの使い方をレクチャーし、正しいフォームや効果的なトレーニング方法をしっかりサポートします。初めての方でも安心してトレーニングを始められる環境を提供し、あなたの目標達成を全力でお手伝いします。
							</p>
						</li>
						<li>
							<h3>The Fit</h3>
							<em>セミパーソナルトレーニング</em>
							<p>
								「The
								Fit」は、最大月8回通える少人数制のセミパーソナルジムです。有資格トレーナーが一人ひとりに寄り添い、目標や体力に合わせた最適なトレーニングを提案します。初めての方でも安心して続けられる環境を整え、継続率No.1を誇ります。リーズナブルな価格でありながら、トレーナーによる本格的なトレーニングを受けることができます。
							</p>
						</li>
					</ul>
				</Inner>
			</section>

			<section className={styles.price}>
				<Title h2="PRICE" />
				<Inner>
					<div className={styles.card}>
						<span className={styles.gymname}>
							WE ARE THE FIT
							<br />
							用賀店
						</span>
						<span className={styles.monthlyPrice}>
							<span>¥7,980</span> / 月<small>（税込 ¥8,778）</small>
						</span>
						<Link to="https://thefit.jp/news/join" className={styles.button} onClick={() => send(`yoga`)}>
							入会はこちら
						</Link>
					</div>
					<table className={styles.table}>
						<tbody>
							<tr>
								<th>登録店舗での全てのワークアウトマシーンとフロアの利用</th>
								<td>
									<div className={styles.checked}>checked</div>
								</td>
							</tr>
							<tr>
								<th>スタッフによるカウンセリングとオリエンテーション</th>
								<td>
									<div className={styles.checked}>checked</div>
								</td>
							</tr>
							<tr>
								<th>初心者向けベーシックサポート</th>
								<td>
									<div className={styles.checked}>checked</div>
								</td>
							</tr>
							<tr>
								<th>体組成分析機の利用</th>
								<td>
									<div className={styles.checked}>checked</div>
								</td>
							</tr>
							<tr>
								<th>
									水素水サーバーの利用<sup>※1</sup>
								</th>
								<td>
									<div className={styles.exTax}>
										<span>¥1,000</span>/ 月
									</div>
									<div className={styles.inTax}>
										（税込 <span>¥1,080</span> / 月）
									</div>
								</td>
							</tr>
							<tr>
								<th>
									パーソナルロッカーの利用<sup>※2</sup>
								</th>
								<td>
									<div className={styles.exTax}>
										<span>¥1,000</span>/ 月
									</div>
									<div className={styles.inTax}>
										（税込 <span>¥1,100</span> / 月）
									</div>
								</td>
							</tr>
							<tr>
								<th>プロテインサーバーの利用</th>
								<td>
									<div className={styles.exTax}>
										<span>¥1,200</span>/ 月
									</div>
									<div className={styles.inTax}>
										（税込 <span>¥1,296</span> / 月）
									</div>
								</td>
							</tr>
							<tr>
								<th>セミパーソナルプラン</th>
								<td>
									<div className={styles.flex}>
										<div>
											<div className={styles.exTax}>
												<span>¥15,000</span>/ 月4回
											</div>
											<div className={styles.inTax}>
												（税込 <span>¥16,500</span> / 月4回）
											</div>
										</div>
										<div>
											<div className={styles.exTax}>
												<span>¥20,000</span>/ 月8回
											</div>
											<div className={styles.inTax}>
												（税込 <span>¥22,000</span> / 月8回）
											</div>
										</div>
									</div>
								</td>
							</tr>
						</tbody>
					</table>
					<div className={styles.caption}>
						<ol>
							<li>
								水素水サーバーは¥1,000（税込¥1,080）/月が基本料金になります。入会時の特典として「2か月無料」でご利用頂けます。
							</li>
							<li>パーソナルロッカーの利用は¥1,000（税込¥1,100）/月が基本料金になります。</li>
						</ol>
					</div>
				</Inner>
			</section>

			<section className={styles.facility}>
				<Title
					h2="FACILITIES"
					sub={
						<div className={styles.subtitle}>
							トレーニングに慣れている方、初級フロアでは物足りなくなった方向けに、最新マシーンを揃えた上級者フロアを用意しています。特にフリーウェイトマシンの種類の豊富さには自信があります。ダンベルも最高50kgまでご用意。
						</div>
					}
				/>
				<Facility
					items={[
						{
							image: `/gyms/yoga/facility_01.webp`,
							caption: `トレーニングへのスイッチを入れてくれる入口。日常からの切り替えで「さあ、やろう！」と言うワークアウトへの集中力をより高められます。`,
						},
						{
							image: `/gyms/yoga/facility_02.webp`,
							caption: `ランニングマシン、バイクと有酸素トレーニングに最適なマシンを揃えております。台数も多くございますので、待ち時間もあまり気にせずご利用いただけます。`,
						},
						{
							image: `/gyms/yoga/facility_03.webp`,
							caption: `ワークアウト初心者でも扱いやすいマシンを多数取り揃えております。スタッフカウンターもございますので、ご質問などあればお気軽にお声掛け下さい。`,
						},
						{
							image: `/gyms/yoga/facility_04.webp`,
							caption: `部位ごとに必要なマシンをご用意。人気のマシンは複数台ご用意しております。スタッフのサポートが必要な場合はお気軽にお申し付けください。`,
						},
						{
							image: `/gyms/yoga/facility_05.webp`,
							caption: `最大5名まで利用可能なストレッチエリアをご用意。アクセサリも豊富にございますので、身体のコンディションを整えるのに最適です。`,
						},
						{
							image: `/gyms/yoga/facility_06.webp`,
							caption: `女性専用の更衣室エリアもあり安心度を強化。無料で使えるフリーロッカーもフロアと更衣室付近、ランニングマシン付近と豊富にご用意しております。`,
						},
						{
							image: `/gyms/yoga/facility_07.webp`,
							caption: `身体を確認、フォームを確認するための鏡を全面に設置。あらゆる角度からワークアウトを見つめる事が可能です。`,
						},
						{
							image: `/gyms/yoga/facility_08.webp`,
							caption: `部位ごとに必要なマシンを設置。人気の高いパワーラックエリートは3台とケーブルが2台、スミス2台と、マシンへの情熱はご覧いただければご理解いただけるはずです。`,
						},
						{
							image: `/gyms/yoga/facility_09.webp`,
							caption: `マシンの設置台数は都内の24時間ジムでは考えられないほど豊富にご用意。皆様のワークアウトに必要な1台がきっと見つかるはずです。`,
						},
						{
							image: `/gyms/yoga/facility_10.webp`,
							caption: `ダンベルは50kgまでご用意。ダンベルトレーニングのエリアも広く、ダンベルミットもございますので、高重量でのトレーニングも安心してご利用頂けます。`,
						},
					]}
				/>
			</section>

			<section className={styles.access}>
				<Inner>
					<div className={styles.accessGrid}>
						<div className={styles.accessTitle}>
							<h2>ACCESS</h2>
						</div>
						<div className={styles.accessData}>
							<div className={styles.accessName}>WE ARE THE FIT YOGA</div>
							<div className={styles.accessAddress}>
								〒158-0097 東京都世田谷区用賀4丁目3-1
								<br />
								ファースト用賀ビル3F
							</div>
							<div className={styles.accessTel}>TEL：03-6411-7177</div>
							<div className={styles.accessOther}>
								東急電鉄田園都市線 用賀駅から徒歩1分
								<br />
								24 時間営業<small>（スタッフ常駐時間 11:00～15:00、16:00～20:00）</small>
							</div>
						</div>
						<div className={styles.accessMap}>
							<div className={styles.accessPlacer}>
								<div>
									<GoogleMap center={{ lat: 35.62732022748413, lng: 139.63484787055742 }} />
								</div>
							</div>
						</div>
					</div>
				</Inner>
			</section>

			<ReadyToGo />
		</div>
	)
}

export default GymPage
